import { memo, useEffect } from "react";
import PropTypes from "prop-types";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./FaqArticle.scss";
import { sendTagOnFaqArticlePage } from "app/utils/analytics";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const FaqArticle = ({ title, content = [] }) => {
	useEffect(() => {
		if (title) {
			sendTagOnFaqArticlePage(title);
		}
	}, [title]);

	return (
		<div className="faq-article">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL}
				variantMD={TYPOGRAPHY_VARIANTS.XL5}
				isBold
				className="faq-article__title"
			>
				{title}
			</Typography>
			<Paragraphs enableHTMLFormatting={true} paragraphs={content} />
		</div>
	);
};

FaqArticle.propTypes = {
	title: PropTypes.string,
	content: PropTypes.array,
};

export default memo(FaqArticle);
